import { useEffect } from "react";
import { OPEN_MODAL_EVENT, CLOSE_MODAL_EVENT } from "../modal-events";
export var useModalEvents = function (_a) {
    var openModal = _a.openModal, closeModal = _a.closeModal;
    useEffect(function () {
        var openModalEvent = function (event) {
            var customEvent = event;
            openModal((customEvent === null || customEvent === void 0 ? void 0 : customEvent.detail) || {});
        };
        window.addEventListener(OPEN_MODAL_EVENT, openModalEvent);
        window.addEventListener(CLOSE_MODAL_EVENT, closeModal);
        return function () {
            window.removeEventListener(OPEN_MODAL_EVENT, openModalEvent);
            window.removeEventListener(CLOSE_MODAL_EVENT, closeModal);
        };
    }, [openModal]);
};
